import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPSData } from '../../../../../shared/models/ips-data';
import { Model } from '../../../../../shared/models/model';
import { ModelService } from '../../../../../shared/services/model.service';
import { SensorService } from '../../../../../shared/services/sensor.service';
import { TranslateService } from '@ngx-translate/core';
import { subDays } from 'date-fns';
import 'chartjs-adapter-date-fns';
import { forkJoin, map } from 'rxjs';

@Component({
  selector: 'app-modele-modal-mobile',
  templateUrl: './modele-modal-mobile.component.html',
  styleUrl: './modele-modal-mobile.component.scss'
})
export class ModeleModalMobileComponent {
  @Input() showDialog: boolean = false;
  @Input() ipsData!: IPSData;
  @Output() showDialogChange = new EventEmitter<boolean>();

  modelSelected! : Model;

  modelForecastResult: any;
  modelLastestForecastResult: any;
  modelRealTimeResult: any;
  modelSeuils: any;

  loading: boolean = false;

  today: Date;
  endDate: string;
  startDate: string;

  partenaireTitle: string | undefined = undefined;
  partenaireImage: string | undefined = undefined;

  constructor(private modelService: ModelService, private sensorService: SensorService, private translate: TranslateService){
    this.today = new Date();
    this.endDate = this.today.toISOString().split('T')[0];
    this.startDate = subDays(this.today, 365*10).toISOString().split('T')[0];
  }

  onDialogShow(): void {
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement) {
        activeElement.blur();
    }

    if(this.ipsData) {
      this.initModelDataRealTime();
      this.initModelDataForecast();
    }
  }

  initModelDataForecast(){
    this.loading = true;
    this.modelService.getResult(this.ipsData.modelId).subscribe((result) =>{
      this.modelForecastResult = result;
      this.loading = false;
    },
    (error) => {
      this.loading = false;
      console.error(error);
    });

    this.loading = true;
    this.modelService.getLatestResult(this.ipsData.modelId).subscribe((result) =>{
      this.modelLastestForecastResult = result;
      this.loading = false;
    },
    (error) => {
      this.loading = false;
      console.error(error);
    });

    this.loading = true;
    this.modelService.getModelData(this.ipsData.modelId).subscribe((res) => {
      this.modelSelected = res;

      this.partenaireTitle = res.descriptionPartenaire;
      this.partenaireImage = res.logoPartenaire;

      res.donneeModele.forEach(sensor => {
        if(sensor.capteur.typeDonnee.type == "Piezo"){
          const codeBSS = this.ipsData.identifier;

          if (codeBSS){
            this.sensorService.getSensorSeuils(sensor.capteur.typeDonnee.type, codeBSS).subscribe((sensorSeuils) => {
              this.modelSeuils = sensorSeuils;
            });
          }
        }
      });
    });
    this.loading = false;

  }

  initModelDataRealTime(){

    this.loading = true;
    const params = `startDate=${this.startDate}&endDate=${this.endDate}`;

    this.modelService.getModelData(this.ipsData.modelId).subscribe((res) => {
      const requests = res.donneeModele.map((sensor) => {
        return this.sensorService.getSensorDataRealtime(sensor.capteur.typeDonnee.type, sensor.capteur.identifier, params).pipe(
          map((sensorData) => ({
            SensorType: sensor.capteur.typeDonnee.type,
            result: sensorData
          }))
        );
      });

      // Utilisation de forkJoin pour attendre que toutes les requêtes soient terminées
      forkJoin(requests).subscribe((results) => {
        this.modelRealTimeResult = results;
        this.loading = false; // Mettre à jour le loading après que toutes les données sont récupérées
      },
      (error) => {
        this.loading = false;
        console.error(error);
      });
    });

    this.loading = false;
  }

  onCancel() {
    this.showDialogChange.emit(false);
    this.modelForecastResult = null;
    this.modelRealTimeResult = null;
  }

}
